import React, { useState } from "react";
import {
  menuUrl,
  tableTitle,
  keyColumn,
  tableColumn,
  breadCrumbs,
  filters as rawFilters,
} from "@screens/user-administration/notification/notification-list/model/notification-list.constants";
import { getFilterData } from "@utils/common";
import {
  constructFilterDataAndGetQueryString,
  getFilterQueryString,
} from "@utils/filters.util";
import { APP } from "@constants/app.constants";
import { useHistory } from "react-router-dom";
import { checkMenuAccess } from "@utils/menu-auth";
import {
  deleteNotificationDataApi,
  getNotificationDataApi,
} from "./notification-list.component.service";
import MESSAGES from "@constants/messages.constants";
import { useDispatch, useSelector } from "react-redux";
import { setAlertMessage } from "@reducers/alert.reducer";
import NotificationListTemplateComponent from "./notification-list-template.component";
import PermissionDeniedComponent from "@screens/permission-denied/permission-denied.component";

const {
  ALERT_TYPES: { SUCCESS, ERROR },
  NOTIFICATION_ALERTS: { DELETE_ALERT },
} = MESSAGES;
const { ROWS_PER_PAGE } = APP;

const NotificationListComponent = () => {
  const { filterList } = useSelector((state) => state.filter);
  const [tableData, setTableData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const history = useHistory();
  const dispatch = useDispatch();
  const filters = getFilterData(filterList, menuUrl, "filter");
  const menuAccess = checkMenuAccess(menuUrl, "read");

  const getNotificationData = async (params = null) => {
    // console.log({ params });
    const queryStr = getFilterQueryString(menuUrl, params);
    const notificationData = await getNotificationDataApi({
      ...params,
      filters: queryStr,
    });
    if (notificationData.status) {
      // console.log(notificationData);
      setTableData(notificationData.data);
      setTotalCount(notificationData.totalCount);
    }
  };

  const handleCreateClick = () => {
    history.push(`/${menuUrl}/create`);
  };

  const deleteRecords = async (selected) => {
    const deleteAccess = checkMenuAccess(menuUrl, "delete");
    if (deleteAccess) {
      const response = await deleteNotificationDataApi(selected);
      if (response.status) {
        dispatch(
          setAlertMessage({ type: SUCCESS, message: DELETE_ALERT, viewed: 0 })
        );
        getNotificationData({
          orderBy: "created_at",
          sortBy: "desc",
          skip: 0,
          limit: ROWS_PER_PAGE,
        });
      } else {
        dispatch(
          setAlertMessage({ type: ERROR, message: response.message, viewed: 0 })
        );
      }
    } else
      dispatch(
        setAlertMessage({
          type: ERROR,
          message: "Permission denied to delete",
          viewed: 0,
        })
      );
  };

  const handleDownload = async (filters = null) => {
    const queryStr = getFilterQueryString(menuUrl, filters);
    // console.log("download triggered", filters, queryStr);
    // // console.log({
    //   url: `${SETTING_EXPORT}?token=${token}${queryStr}`,
    // });
  };

  const submitFilter = (filters) => {
    const queryStr = constructFilterDataAndGetQueryString(filters, menuUrl);
    // console.log({ queryStr });
    getNotificationData({
      orderBy: "created_at",
      sortBy: "desc",
      skip: 0,
      limit: ROWS_PER_PAGE,
      filters: queryStr,
    });
  };

  return menuAccess ? (
    <NotificationListTemplateComponent
      templateModal={{
        tableTitle,
        keyColumn,
        breadCrumbs,
        tableColumn,
        tableData,
        totalCount,
        filters: filters ? filters : rawFilters,
      }}
      templateEvents={{
        getNotificationData,
        handleCreateClick,
        deleteRecords,
        handleDownload,
        submitFilter,
      }}
    />
  ) : (
    <PermissionDeniedComponent />
  );
};

export default NotificationListComponent;
